import React, { useState, Fragment } from 'react';
import Localize from 'react-intl-universal';

import { Formik, Form } from 'formik';

import LoadingButton from '@mui/lab/LoadingButton';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import { styled } from '@mui/material/styles';
import Typography from '@mui/material/Typography';

import CreateFieldsFromConfig from '@components/CreateFormFields/CreateFieldsFromConfig';

import initialValues from './initialValues';
import useCreateSchema from './useCreateSchema';
import { resetPasswordConfig1, resetPasswordConfig2 } from '../../config';

const StyledButton = styled(Button)(() => ({
  fontWeight: '500',
  fontSize: '16px',
  textTransform: 'none'
}));

const StyledListItem = styled(ListItem)(() => ({
  display: 'list-item',
  fontSize: '12px'
}));

const StyledLoadingButton = styled(LoadingButton)(({ theme }) => ({
  fontWeight: '500',
  fontSize: '16px',
  textTransform: 'none',
  borderRadius: '1',
  backgroundColor: theme.palette.primary.main,
  color: theme.palette.common.white,
  '&.MuiLoadingButton-loading': {
    width: '12rem'
  },
  '&:hover': {
    backgroundColor: theme.palette.primary.light
  }
}));

const ResetPassword = () => {
  const [open, setOpen] = useState(false);
  const validationSchema = useCreateSchema();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const onSubmit = ({ setSubmitting }) => {
    // values, { setSubmitting }
    setSubmitting(false);
    handleClose();
  };

  return (
    <Fragment>
      <StyledButton onClick={handleClickOpen}>{Localize.get('Booking.resetPassword')}</StyledButton>
      <Dialog
        open={open}
        fullWidth
        maxWidth='sm'
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <Formik
          validateOnMount
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={onSubmit}
        >
          {({ handleSubmit, isSubmitting, isValid }) => (
            <>
              <DialogTitle id='alert-dialog-title'>
                {Localize.get('Booking.resetPassword')}
              </DialogTitle>
              <DialogContent>
                <Form>
                  <CreateFieldsFromConfig config={resetPasswordConfig1} />
                  <List sx={{ listStyleType: 'disc', paddingLeft: 2.5 }}>
                    <StyledListItem disablePadding>
                      <Typography sx={{ fontSize: '12px' }}>
                        {Localize.get('MyProfile.minCharacter')}
                      </Typography>
                    </StyledListItem>
                    <StyledListItem disablePadding>
                      <Typography sx={{ fontSize: '12px' }}>
                        {Localize.get('MyProfile.oneUppercase')}
                      </Typography>
                    </StyledListItem>
                    <StyledListItem disablePadding>
                      <Typography sx={{ fontSize: '12px' }}>
                        {Localize.get('MyProfile.oneNumber')}
                      </Typography>
                    </StyledListItem>
                    <StyledListItem disablePadding>
                      <Typography sx={{ fontSize: '12px' }}>
                        {Localize.get('MyProfile.oneSpecialCharacter')}
                      </Typography>
                    </StyledListItem>
                  </List>
                  <CreateFieldsFromConfig config={resetPasswordConfig2} />
                </Form>
              </DialogContent>
              <DialogActions sx={{ mr: 2 }}>
                <Button sx={{ textTransform: 'none', fontSize: '1rem' }} onClick={handleClose}>
                  {Localize.get('MyProfile.dismiss')}
                </Button>
                <StyledLoadingButton
                  disabled={!isValid}
                  loading={isSubmitting}
                  variant='contained'
                  loadingPosition='start'
                  onClick={handleSubmit}
                  startIcon={<></>}
                >
                  {Localize.get('MyProfile.saveChanges')}
                </StyledLoadingButton>
              </DialogActions>
            </>
          )}
        </Formik>
      </Dialog>
    </Fragment>
  );
};

export default ResetPassword;
